import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = ({ children = undefined, redirectPath, isAllowed }) => {
  if (!isAllowed) return <Navigate to={redirectPath} replace />;

  return children ?? <Outlet />;
};

export default ProtectedRoute;
